function isEqual(valueA, valueB) {
  return valueA === valueB;
}

export default isEqual;
